<script lang="ts">
	import { createParticles } from '$lib/features/playtip/lib/avatarDrawer.js';
	import Particles from './particles';
	interface Props {
		colors?: string[] | null;
		shapes?: string[] | null;
	}

	let { colors = null, shapes = null }: Props = $props();

	const instanceId = `tsparticles-${crypto.randomUUID()}`;

	let particlesConfig = $derived(
		createParticles(colors, shapes) as
			| import('@tsparticles/engine').RecursivePartial<import('@tsparticles/engine').IOptions>
			| undefined
	);

	let onParticlesLoaded = (_detail: {
		particles: import('@tsparticles/engine').Container | undefined;
	}) => {};
</script>

<div class="absolute z-10 h-full w-full">
	<Particles
		id={instanceId}
		class="relative h-full w-full"
		options={particlesConfig}
		onparticlesloaded={onParticlesLoaded}
	/>
</div>
